import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { SortByOption } from '@sonar-software/sonar-ts-types';

export const timelineSortOptions: Array<SortByOption> = [
	{
		direction: 'descending',
		key: 'date',
		label: COPY_SPECIFIC.DETECTED_DATE
	},
	{
		direction: 'ascending',
		key: 'modifiedBy',
		label: COPY_SPECIFIC.MODIFIED_BY
	}
];
